var _path, _path2, _rect, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47095 28.836L16.9946 6.21785C17.7326 5.14259 18.953 4.5 20.2571 4.5H24.497C25.5897 4.5 26.4755 5.38582 26.4755 6.47853V18.9433H12.9849",
    stroke: "#2D3D69",
    strokeWidth: 2.9678
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0413 13.5516H21.0091V24.3346H18.0413V18.9431V13.5516Z",
    fill: "#AC2628"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9705,
    y: 17.4702,
    width: 12.0343,
    height: 2.94171,
    fill: "#AC2628"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0046,
    y: 17.4702,
    width: 2.94171,
    height: 2.94171,
    fill: "#AC2628"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4755 16.3336L27.9463 15.197V17.4702H25.0046L26.4755 16.3336Z",
    fill: "#AC2628"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.54d1d37ef2b45d2963d38d4752749940.svg";
export { ForwardRef as ReactComponent };